import React from 'react'
import AllIndents from '../../AllIndents/AllIndents'

const IndentRequest = () => {
  return (
    <div>
      <AllIndents/>
    </div>
  )
}

export default IndentRequest
